import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Subtitle } from 'src/pages/scheduleSurgery/components/surgery/SurgeryReviewAndSuccess.styled';

export const SurgeryNotesMainContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;
export const SurgeryNotesContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 8px;
    word-break: ${({ wordBreak }) => (wordBreak ? wordBreak : 'normal')};
`;

export const NoteGroupHeader = styled(Subtitle)`
    width: 100%;
`;

export const UpdatedSurgeryDateContainer = styled.div`
    display: flex;
    flex-wrap: wrap;    
`;

export const UpdatedSurgeryDateTitle = styled.div`
font-family: AvenirNextWorld demi;
color: #202124;
font-size: 14px;
margin-bottom: 8px;

${media.mobileDevice`
margin-bottom:${({ marginBottom }) =>
    marginBottom ? marginBottom : '8px'};
`}
`;